import { render, staticRenderFns } from "./PlusProductModal.vue?vue&type=template&id=56457fa0&scoped=true"
import script from "./PlusProductModal.vue?vue&type=script&lang=ts"
export * from "./PlusProductModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56457fa0",
  null
  
)

export default component.exports